 <template>
  <div class="trafficr">
    <m-title :titlelist="listitem"></m-title>
    <div class="tr_content">
      <div class="cont-top">
        <div class="top-header">
          <div class="header-left"></div>
          <div class="header-txt">
            限行设置
          </div>
        </div>
        <div class="top-content">
          <div class="hc-tr">
            <div class="hc-label">货场限行:</div>
              <el-checkbox v-for="item in hcarr" v-model="checkedhc" :label="item.val" :key="item.id" @change="gethcarr()">{{ item.val }}</el-checkbox>
          </div>
          <div class="ryc-tr">
            <div class="hc-label">燃油车限行:</div>
            <el-checkbox-group v-model="checkedryc" @change="rycCheckedCitiesChange">
              <el-checkbox v-for="item in rycarr" :label="item.val" :key="item.id">{{ item.val }}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="trqc-tr">
            <div class="hc-label">天然汽车限行:</div>
            <el-checkbox-group v-model="checkedtrq" @change="trqcCheckedCitiesChange">
              <el-checkbox v-for="item in trqcarr" :label="item.val" :key="item.id">{{ item.val }}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="xnyc-tr">
            <div class="hc-label">新能源车限行:</div>
            <el-checkbox-group v-model="checkedxny" @change="xnycCheckedCitiesChange">
              <el-checkbox v-for="item in xnycarr" :label="item.val" :key="item.id">{{ item.val }}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="date-tr">
            <div class="hc-label">限行日期：</div>
            <!-- <el-date-picker v-model="datevalue" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd">
            </el-date-picker> -->
            <el-date-picker
                v-model="startday"
                style="width: 180px;"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
            </el-date-picker>
            至
            <el-date-picker
                v-model="endday"
                type="date"
                style="width: 180px;"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
            </el-date-picker>
          </div>
        </div>
        <div class="btn">
          <button class="tr-btn" @click="insertdrivingplan">保存</button>
          <button class="clear-btn" @click="clearplan">重置</button>
        </div>
      </div>
      <div class="tr-bottom">
      <div class="bottom-top">
         <div class="bottom-date">
          <!-- <div class="date-label"> -->
            <!-- 设置限行日期： -->
          <!-- </div> -->
          <!-- <el-date-picker
            v-model="xianxingvalue"  type="date"
            placeholder="选择日期"  format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd">
          </el-date-picker> -->
        </div>
        <div class="bottom-btn">
          <button class="search" @click="search">查询</button>
          <!-- <button class="reset">重置</button> -->
        </div>
      </div>
        <div class="tr-info">
          <div class="info-item">
            <div class="item-title">
              <div class="title-left">
                <img src="../../assets/xianxing/szrq_icon.png" alt="">
                <span class="txt">限行方案</span>
                <!-- <span class="date">2023-11-17</span> -->
              </div>
            </div>
            <div class="tr-info-item">
              <div class="item-cont" v-for="item in fanganarr" :key="item.restrictPlanId">
              <div class="cont-hc">
                <div class="item-left">
                  <div class="left-cont">
                    <div class="cont-label">{{item.restrictName}}：</div>
                    <el-tag v-for="(it,index) in item.restrictTypeVo" :key="index">{{ it.restrictValueName }}</el-tag>
                  </div>
                  <div class="cont-xxrq">
                    <div class="cont-label">限行日期：</div>
                    <div class="cont-date">{{ dataFormat(item.startday) }} 至 {{ dataFormat(item.endday) }}</div>
                  </div>
                </div>
                <div class="item-right">
                  <span class="shixiao" v-if="item.state==1">已失效</span>
                  <button class="shixiaobtn" v-else @click="checkstate(item)">取消规则</button>
                </div> 
              </div>
            </div>
            </div>
           
          </div>
        </div>
      </div>


      <!-- <div class="tr_scheme" v-for="(item, index) in allmsg" :key="item.restrictPlanId">
        <div class="tr_switch">
          <m-switch v-model="item.btnstate" @click="clickFun($event, item, index)" mstyle="background: #13D168;">{{
            item.restrictName }}</m-switch>
        </div>
        <div class="item_list">
          <div class="line">
            <span class="line_txt"> 排放标准: </span>
            <div class="line_item" v-for="item1 in item.restrictTypeVo[0].restrictValueVo" :key="item1.restrictValue">
              <m-chebox v-model="item1.btnstate" @click="clickFun(...[, , index])">
                <span>{{ item1.val }}</span>
              </m-chebox>
            </div>
          </div>
          <div class="line">
            <span class="line_txt"> 单双号限行: </span>
            <div class="line_item" v-for="item2 in item.restrictTypeVo[1].restrictValueVo" :key="item2.restrictValue">
              <m-chebox v-model="item2.btnstate" @click="clickFun(...[, , index])">
                <span>{{ item2.val }}</span>
              </m-chebox>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle.vue";
import mChebox from "@/components/mChebox.vue";
import mSwitch from "@/components/mSwitch.vue";
export default {
  data() {
    return {
      listitem: [{ name: "货场管理" }, { name: "限行设置" }],
      allmsg: [],
      rycarr: [],//燃油车
      checkedryc:[],
      trqcarr:[],//天然汽车
      checkedtrq:[],
      xnycarr:[],//新能源车
      checkedxny:[],
      hcarr:[],//货场
      checkedhc:[],
      // datevalue: '',
      startday:"",
      endday:"",
      xianxingvalue:"",
      huochangcheck:[],
      tianranqicheck:[],
      xinnengyuancheck:[],
      ranyouche:[],
      fanganarr:[],
    };
  },
  components: {
    mTitle,
    mChebox,
    mSwitch,
  },
  created() {
    this.getList();
    this.getcarinfolist()
  },
  methods: {
    getcheck(checked,carlist){
      let arr=null;
      let hccheck=[]
      if(checked.length > 0){
        for (let i = 0; i < checked.length; i++) {
         arr= carlist.find(it=>{
            if(it.val==checked[i]) {
              return  it
            }
          })
          hccheck.push(arr)
        }
      }
      return hccheck
    },
    gethcarr(){
      this.huochangcheck=this.getcheck(this.checkedhc,this.hcarr)
    },
    rycCheckedCitiesChange(value) {
      this.ranyouche=this.getcheck(value,this.rycarr)
    },
    trqcCheckedCitiesChange(value) {
      this.tianranqicheck=this.getcheck(value,this.trqcarr)
    },
    xnycCheckedCitiesChange(value) {
      this.xinnengyuancheck=this.getcheck(value,this.xnycarr)
    },
    clearplan(){
      this.checkedryc=[]
      this.checkedtrq=[]
      this.checkedxny=[]
      this.checkedhc=[]
      // this.datevalue=""
      this.startday=""
      this.endday=""
    },
    async insertdrivingplan(){
      if(this.startday==""||this.endday==""){
        this.$message("限行日期不能为空")
        return
      }
      let postarr=[this.huochangcheck,this.ranyouche,this.tianranqicheck,this.xinnengyuancheck]
      let postlist=[]
      for (let i = 0; i < postarr.length; i++) {
        if(postarr[i].length > 0) {
          let obj={
        restrictName:'',
        startday:this.startday,
        endday:this.endday,
        state:2,
        restrictTypeVo:[]
      }
          obj.restrictName=postarr[i][0].typeName
          postarr[i].map(item=>{
            let restrictobj={
              restrictValue:"",
              restrictType:"",
              val:""
            }
            restrictobj.restrictValue=item.id
            restrictobj.val=item.val
            restrictobj.restrictType=item.typeId
            obj.restrictTypeVo.push(restrictobj)
          })
          postlist.push(obj)
        }
      }
      const {data}=await this.$http(
        "api1",
        "/restrict/drivingplan/insertdrivingplan",
        "post",
        postlist
      )
      if(data.msg=="success"){
        this.getList()
      }
    },
    async getcarinfolist(){
      const { data } = await this.$http("api1", "/sys/dic/selectDiclist", "post", 
         ["燃油车限行","天然气车辆限行","新能源车辆限行","货场限行"],
      );
      for (let i = 0; i < data.data.length; i++) {
        data.data[i].typeName=="燃油车限行"?this.rycarr.push(data.data[i]):data.data[i].typeName=="天然气车辆限行"?this.trqcarr.push(data.data[i]):data.data[i].typeName=="新能源车辆限行"?this.xnycarr.push(data.data[i]):this.hcarr.push(data.data[i])
      }
    },


    dataFormat(dt, long) {
				if (!dt) return "";
				let date = new Date(dt),
					yy = date.getFullYear(),
					mon = date.getMonth() + 1,
					dd = date.getDate(),
					hh = date.getHours(),
					mm = date.getMinutes();
				if (long === "long") return `${yy}-${mon}-${dd} ${hh}:${mm}`
				return `${yy}-${mon}-${dd}`
			},
      // 修改限行状态
      async checkstate(item){
        item.state = 1
        const {data}=await this.$http(
          "api1",
          "/restrict/drivingplan/updatedrivingplan",
          "post",
          item
        );
        if(data.msg!="success") return 

        this.getList()
      },
      search(){
        this.getList()
      },
    async getList() {
      // let allmsg = [],
      //   restrictTypeVo = [],
      //   str = "";
      const { data:val } = await this.$http(
        "api1",
        "/restrict/drivingvalue/drivingcheckvaluelist",
        "get"
      );
      this.fanganarr = val.data;
      // role3.data.forEach((item) => {
      //   item.restrictTypeVo.forEach((item1) => {
      //     item1.restrictValueVo = item1.restrictValueVo.reduce(
      //       (result, item2) => {
      //         result.push(item2.restrictValue + "");
      //         return result;
      //       },
      //       []
      //     );
      //   });
      // });
      //获取燃油车
      
  



      // const { data: role2 } = await this.$http("api1", "/sys/dic/list", "get", {
      //   dictionaryType: "排放标准",
      // });

      // restrictTypeVo[0] = role2.data.reduce(
      //   (result, item, index) => {
      //     if (!index) result.restrictType = Number(item.typeId);
      //     result.restrictValueVo.push({
      //       restrictValue: item.id,
      //       val: item.val,
      //       btnstate: 0,
      //     });
      //     return result;
      //   },
      //   { restrictType: null, restrictValueVo: [] }
      // );

      // const { data: role1 } = await this.$http("api1", "/sys/dic/list", "get", {
    //     dictionaryType: "单双号限行",
    //   });
    //   restrictTypeVo[1] = role1.data.reduce(
    //     (result, item, index) => {
    //       if (!index) result.restrictType = Number(item.typeId);
    //       result.restrictValueVo.push({
    //         restrictValue: item.id,
    //         val: item.val,
    //         btnstate: 0,
    //       });
    //       return result;
    //     },
    //     { restrictType: null, restrictValueVo: [] }
    //   );

    //   str = JSON.stringify(restrictTypeVo);

    //   const { data: role0 } = await this.$http(
    //     "api1",
    //     "/restrict/drivingplan/drivingplanlist",
    //     "get"
    //   );
    //   allmsg = role0.data.reduce((result, item) => {
    //     result.push({
    //       restrictName: item.restrictName,
    //       restrictPlanId: Number(item.id),
    //       state: item.state,
    //       btnstate: item.state == 1 ? 0 : 1,
    //       restrictTypeVo: JSON.parse(str),
    //     });
    //     return result;
    //   }, allmsg);
    //   role3.data.forEach((item) => {
    //     item.restrictName
    //       ? allmsg.forEach((item2) => {
    //         item2.restrictName === item.restrictName
    //           ? item.restrictTypeVo.forEach((item3) => {
    //             item2.restrictTypeVo.forEach((itemf) => {
    //               itemf.restrictType == item3.restrictType
    //                 ? itemf.restrictValueVo.forEach((item5) => {
    //                   item3.restrictValueVo.includes(item5.restrictValue)
    //                     ? (item5.btnstate = 1)
    //                     : "";
    //                 })
    //                 : "";
    //             });
    //           })
    //           : "";
    //       })
    //       : "";
    //   });
    //   console.log(allmsg);
    //   this.allmsg = allmsg;
    // },
    // clickFun(val, info, itm) {
    //   console.log(val, info, itm);
    //   info ? (info.state = val ? 2 : 1) : "";
    //   this.saveinfo(JSON.stringify(this.allmsg), itm);
    // },
    // async saveinfo(info, itm) {
    //   let obj = JSON.parse(info),
    //     i;
    //   obj.forEach((item) => {
    //     delete item.btnstate;
    //     item.restrictTypeVo.forEach((item1) => {
    //       i = 0;
    //       for (i; i < item1.restrictValueVo.length; i++) {
    //         if (!item1.restrictValueVo[i].btnstate) {
    //           item1.restrictValueVo.splice(i, 1);
    //           i--;
    //         } else {
    //           delete item1.restrictValueVo[i].btnstate;
    //           delete item1.restrictValueVo[i].val;
    //         }
    //       }
    //     });
    //   });
    //   console.log(obj,itm);
    //   const { data } = await this.$http(
    //     "api1",
    //     "/restrict/drivingplan/updatedrivingplan",
    //     "post",
    //     obj[itm]
    //   );
    //   console.log(data);
    //   if (data.code !== 0) {
    //     this.allmsg[itm].state = 1;
    //     this.allmsg[itm].btnstate = 0;
    //     this.$message({
    //       type: "error",
    //       message: data.msg,
    //     });
      // }



    },
  },
};
</script>
<style lang="scss" scoped>
@mixin start{
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
@mixin between{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.trafficr {
  position: relative;
  height: 100%;

  .tr_content {
    position: absolute;
    top: 50px;
    bottom: 0;
    width: 100%;
    background: #F5F6FA;
    overflow: scroll;
    padding: 10px;
    box-sizing: border-box;
    .cont-top{
      width: 100%;
      background-color: #fff;
      padding: 10px;
      box-sizing: border-box;
      border-radius: 20px;
      .top-header{
        height: 50px;
        @include start;
        .header-left{
          width: 10px;
          height: 20px;
          background: #17B6A1;
          border-radius: 5px;
        }
        .header-txt{
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 600;
          color: #2D3748;
          margin-left: 10px;
        }
      }
      .top-content{
        margin-top: 10px;
        .hc-tr,.ryc-tr,.trqc-tr,.xnyc-tr{
          @include start;
          margin-top: 10px;
          .hc-label{
            color: #17B6A1;
            font-size: 13px;
            margin-right:30px;
          }
        }
      
        .date-tr{
          @include start;
          margin-top: 10px;
          .hc-label{
            color: #17B6A1;
            font-size: 13px;
            margin-right:30px;
          }
        }
      }
      .btn{
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          margin: 10px 0;
          .tr-btn{
            width: 80px;
            height: 32px;
            background: #17B6A1;
            border-radius: 8px;
            color: #fff;
            text-align: center;
            border: none;
          }
          .clear-btn{
            width: 80px;
            height: 32px;
            background: #e8e8e8;
            border-radius: 8px;
            color: #17B6A1;
            text-align: center;
            border: none;
            margin-left: 30px;
          }
        }
    }
    .tr-bottom{
      width: 100%;
      padding: 10px 20px;
      border-radius: 20px;
      box-sizing: border-box;
      background-color: #fff;
      margin-top: 10px;
      height: calc(100% - 270px);
      
      .bottom-top{
        @include between;
        margin:10px 0 ;
        .bottom-date{
          @include start;
          .date-label{
            font-size: 12px;
            font-weight: 500;
            color: #333333;
            margin-right: 20px;
          }
        }
        .bottom-btn{
          display: flex;
          justify-content: flex-end;
          align-items: center;
          
          .search{
            width: 80px;
            height: 30px;
            background: #17B6A1;
            border-radius: 8px;
            font-size: 80%;
            font-family: PingFang SC;
            font-weight: 400;
            color: #fff;
            text-align: center;
            border: none;
          }
          .reset{
            width: 80px;
            height: 30px;
            background: #F5F6FA;
            border-radius: 8px;
            font-size: 80%;
            font-family: PingFang SC;
            font-weight: 400;
            color: #17B6A1;
            text-align: center;
            line-height: 30px;
            border: none;
            margin-left: 19px;
          }
        }
      }
      
      .tr-info{
        padding: 10px;
        box-sizing: border-box;
        background: #EFF1F6;
        border-radius: 16px;
        height: calc(100% - 50px);
        .info-item{
          width: 100%;
          background-color: #F8F9FB;
          border-radius: 8px;
          margin-bottom: 10px;
          height: 100%;
          .item-title{
            background-color: #fff;
            @include between;
            padding: 10px;
            box-sizing: border-box;
            border-radius: 8px;
            .title-left{
              @include start;
              img{
                width: 28px;
                height: 28px;
                margin-left: 5px;
              }
              .txt{
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 600;
                color: #333333;
                display: inline-block;
                margin-left: 5px;
              }
              .date{
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 600;
                color: #333333;
              }
            }
          }
          .tr-info-item{
            height: calc(100% - 67px);
            overflow: auto;
            .item-cont{
             padding: 10px;
            box-sizing: border-box;
            .cont-hc{
              @include between;
              margin-bottom: 10px;
              .item-left{
                width: 90%;
                @include between;
                .left-cont{
                  @include start;
                 .cont-label{
                    margin-right: 20px;
                    color: #333;
                    font-size: 13px;
                  }
                  .el-tag{
                    margin-right: 20px;
                  }
                } 
                .cont-xxrq{
                  @include between;
                  .cont-label{
                    margin-right: 20px;
                    color: #333;
                    font-size: 13px;
                  }
                  .cont-date{
                    color: #7A8294;
                    font-size: 13px;
                  }
                }

                }
              }
              .item-right{
                display: flex;
                justify-content: flex-end;
                align-items: center;
                .shixiao{
                  font-size: 13px;
                  font-family: PingFang SC;
                  font-weight: 400;
                  color: #999999;
                }
                .shixiaobtn{
                  width: 80px;
                  height: 32px;
                  background: #F5F6FA;
                  border-radius: 8px;
                  color: #17B6A1;
                  text-align: center;
                  border: none;
                }
              } 
          }
          }
         
        }
      }
    }
  }

  .tr_scheme {
    position: relative;
    padding: 20px 10px;
    border-top: 1px solid #f3f4f5;

    .tr_switch {
      font-size: 80%;
      height: 50px;
    }

    .item_list {
      font-size: 80%;
      padding: 0 30px;
      border-radius: 5px;
      box-shadow: 0 0 3px rgb(60, 60, 60);

      .line {
        padding: 20px 0;

        .line_txt {
          font-size: 90%;
          font-weight: bold;
          display: inline-block;
          vertical-align: middle;
          margin-right: 20px;
        }

        .line_item {
          display: inline-block;
          vertical-align: middle;
          font-size: 80%;
          padding: 0 10px;
        }
      }
    }
  }
}
</style>